import { __awaiter } from "tslib";
/**
 * Created by wuyanbin on 2019/7/15
 */
import { createStore } from '@souche-f2e/muji';
import { notification } from 'antd';
import Api from '@/services';
import { formatNumOrSpace } from '@/shared/functions';
const mappingData = {
    payTypeSubArr: ['fixedFee', 'fixedRate', 'purchasePrice'],
};
const initData = {
    // 卖家车款分次结算
    moreTimesPay: false,
    // 分批支付的子类型
    moreTimesSubTypes: 'fixedFee',
    // 固定金额的数量
    fixedFeeMoney: '',
    // 固定比列
    FixedRateNum: '',
    FixedRateMin: '',
    FixedRateMax: '',
    // 是否可以编辑
    isEditAble: false,
    // 是否是第一次创建
    isFirstCreate: false,
};
export default createStore({
    state: Object.assign(Object.assign({}, initData), mappingData),
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        RESET_STATE(state) {
            return Object.assign({}, initData);
        },
    },
    effects: {
        resetState(params) {
            this.SET_STATE(Object.assign(Object.assign({}, initData), params));
        },
        // 卖家车款分次结算
        handleChangePayWay(payload, { state }) {
            this.SET_STATE({
                moreTimesPay: payload,
            });
        },
        // 结算子类型更改
        handleChangeSubTypes(payload, { state }) {
            this.SET_STATE({
                moreTimesSubTypes: payload,
            });
        },
        // 固定金额的操作
        handleFixedFeeMoney(payload, { state }) {
            this.SET_STATE({
                fixedFeeMoney: payload,
            });
        },
        // 固定比列的修改
        handleFixedRate(payload, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.SET_STATE({
                    [payload.type]: payload.value,
                });
            });
        },
        // 保存配置
        saveSellerPayConfig(payload, { state, update }) {
            const data = {
                settlementType: Number(state.moreTimesPay),
                payType: state.payTypeSubArr.indexOf(state.moreTimesSubTypes),
                payPercentage: formatNumOrSpace(state.FixedRateNum),
                lowerLimit: formatNumOrSpace(state.FixedRateMin),
                upperLimit: formatNumOrSpace(state.FixedRateMax),
                payAmount: formatNumOrSpace(state.fixedFeeMoney),
            };
            Api.base.createSellerPayConfig({ data, isFirstCreate: state.isFirstCreate }).then((res) => {
                this.getSellerPayConfig({}).then(() => {
                    notification.success({ message: '保存成功' });
                });
            });
        },
        // 取消编辑
        cancelSellerPayConfig(payload, { state, update }) {
            this.getSellerPayConfig({});
        },
        // 编辑配置
        editSellerPayConfig(payload, { state, update }) {
            update({ isEditAble: !state.isEditAble });
        },
        // 查询配置
        getSellerPayConfig(payload, { state, update }) {
            return __awaiter(this, void 0, void 0, function* () {
                yield Api.base.getSellerPayConfig({}).then((res) => {
                    this.SET_STATE({
                        isFirstCreate: false,
                        isEditAble: false,
                        moreTimesPay: res.settlementType === 1,
                        moreTimesSubTypes: state.payTypeSubArr[res.payType] || 'purchasePrice',
                        fixedFeeMoney: formatNumOrSpace(res.payAmountYuanUnit),
                        FixedRateNum: formatNumOrSpace(res.payPercentage),
                        FixedRateMin: formatNumOrSpace(res.lowerLimitYuanUnit),
                        FixedRateMax: formatNumOrSpace(res.upperLimitYuanUnit),
                    });
                });
            });
        },
    },
});
